import type { FieldTransformation, ParamsInner } from '@dialogue/scribe'
import { logger } from 'APP/Lib/Datadog'

type TransformFunc =
  | typeof String.prototype.replace
  | typeof String.prototype.padStart
  | typeof Array.prototype.join

// @TODO FIXME: the type coercion of toTransform is only required
// because we wanted a single method call at the end of the
// switch statement. To avoid excessive refactoring in one instance
// it's been left for now - a proper refactor should handle each case separately

export const transform = (
  toTransform: string | string[],
  operation: FieldTransformation | null | undefined
) => {
  const type = operation?.type
  let params: ParamsInner[] | [RegExp, ParamsInner] | undefined = operation?.params
  let func: TransformFunc | undefined

  switch (type) {
    case 'replace':
      func = (toTransform as string)?.replace
      // Have to use regex replace because the runtime is guaranteed to
      // have replaceAll
      params = [new RegExp(`${params![0]}`, 'g'), params![1]]
      break
    case 'padStart':
      func = (toTransform as string)?.padStart
      // JS padStart uses target length then padding character
      // the opposite of what the API returns
      params = [params![1], params![0]]
      break
    case 'join':
      func = (toTransform as string[])?.join
      break
    default:
      // Unknown operation type
      logger.error(`Unknown operation: ${type}`)
      return toTransform
  }

  if (!func || typeof func !== 'function') {
    logger.error(`Operation: ${type} is not a supported function for ${toTransform}`)
    return toTransform
  }

  // @ts-expect-error: apply with a union of native method overloads (replace/padStart/join) — TS cannot verify 'this' context through the union
  return func?.apply(toTransform, params ?? []) ?? toTransform
}

export default {
  transform,
}
